import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', function() {

    // Function to initialize Swiper and card effects
    function initTallCardFeatures() {
        const sbcMainwrap = document.querySelectorAll('.tall-card-grid');
        sbcMainwrap.forEach(sbcMainwrapEl => {

            // Initialize Swiper
            new Swiper(sbcMainwrapEl, {
                slidesPerView: 1,
                spaceBetween: 20,
                loop: false,
                scrollbar: {
                    el: sbcMainwrapEl.querySelector('.swiper-scrollbar'),
                    draggable: true,
                    hide: false,
                },
                breakpoints: {
                    575: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    991: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                    1024: {
                        slidesPerView: 3.3,
                        spaceBetween: 60,
                    },
                },
            });
        });

        // --- CARD INTERACTION ---
        const cards = document.querySelectorAll('.tall-card');
        let maxTitleHeight = 0;

        // 1️⃣ Find tallest title
        cards.forEach(card => {
            const title = card.querySelector('.tall-card-title');
            if (title) {
                const height = title.offsetHeight;
                if (height > maxTitleHeight) { maxTitleHeight = height; }
            }
        });

        // 2️⃣ Set equal height for all titles
        cards.forEach(card => {
            const title = card.querySelector('.tall-card-title');
            if (title) { title.style.minHeight = maxTitleHeight + 'px'; }
        });

        
        // 3️⃣ Add hover + click effects
        cards.forEach(card => {
            const detailWrap = card.querySelector('.tall-detailwrap');
            const title = card.querySelector('.tall-card-title');

            if (detailWrap) {
                detailWrap.style.maxHeight = '0px';
                detailWrap.style.overflow = 'hidden';
                detailWrap.style.transition = 'max-height 0.6s ease';
            }

            const toggleCard = (isEnter) => {
                if (!detailWrap || !title) {return;}

                if (isEnter) {
                    detailWrap.style.maxHeight = detailWrap.scrollHeight + 'px';
                    title.style.display = 'none';
                } else {
                    detailWrap.style.maxHeight = '0px';
                    title.style.display = 'block';
                }
            };


            // Hover effects
            card.addEventListener('mouseenter', () => toggleCard(true));
            card.addEventListener('mouseleave', () => toggleCard(false));

            // Click toggle (for touch devices ≥1200px)
            card.addEventListener('click', function(e) {
                if (window.innerWidth < 1200) {return;} // optional: only for large screens
                e.stopPropagation();
                const isOpen = detailWrap.style.maxHeight !== '0px' && detailWrap.style.maxHeight !== '';
                toggleCard(!isOpen);
            });
        });

    }

    // Function to destroy swiper + reset
    function destroyTallCardFeatures() {
        const cards = document.querySelectorAll('.tall-card');
        cards.forEach(card => {
            const title = card.querySelector('.tall-card-title');
            const detailWrap = card.querySelector('.tall-detailwrap');
            if (title) {
                title.style.opacity = '1';
                title.style.display = 'block';
                title.style.minHeight = 'auto';
            }
            if (detailWrap) {
                detailWrap.style.maxHeight = 'none';
                detailWrap.style.transition = 'none';
            }
        });
    }

    // --- RUN BASED ON SCREEN WIDTH ---
    function handleResponsiveFeatures() {
        if (window.innerWidth >= 1200) {
            initTallCardFeatures();
        } else {
            destroyTallCardFeatures();
        }
    }

    handleResponsiveFeatures();
    window.addEventListener('resize', () => {
        clearTimeout(window.tallCardResizeTimeout);
        window.tallCardResizeTimeout = setTimeout(handleResponsiveFeatures, 300);
    });
});